
export function checkEmail (e) {
  var reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/
  // var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
  if (reg.test(e)) {
    return true
  } else {
    return false
  }
}

export function checkDeliveryNumber (e) {
  if (e && e.length === 10) {
    return true
  }
  return false
}
